"use client";
import privacyPolicyFallbackContent from "@/data/privacyPolicyFallbackContent.json";

export default function PrivacyPolicy({ privacyPoliciesContent }) {
  privacyPoliciesContent = privacyPoliciesContent || privacyPolicyFallbackContent?.data;
  function toggleAccordion(header) {
    const content = header.nextElementSibling;
    const isActive = header.classList.contains("active");

    document.querySelectorAll(".accordion-header").forEach((h) => {
      h.classList.remove("active");
    });
    document.querySelectorAll(".accordion-content").forEach((c) => {
      c.classList.remove("active");
    });

    if (!isActive) {
      header.classList.add("active");
      content.classList.add("active");
    }
  }
  const headerContent = privacyPoliciesContent.find((item) => item.Heading && item.PageDescription);

  const accordionItems = privacyPoliciesContent.filter(
    (item) => item.PolicyName && item.PolicyDescription
  );

  return (
    <>
      {/* Styles preserved exactly */}
      <style>{`
        
      .hero {
        text-align: center;
        position: relative;
        overflow: hidden;
      }
      .hero-content {
        max-width: 800px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
      }
      .hero h1 {
        font-family: "Spectral", serif;
        font-size: 2rem;
        color: #EDD2B9;
        margin-bottom: 0.5rem;
        font-weight: 700;
      }
      .hero p {
        font-size: 1rem;
        color: #EDD2B9;
        max-width: 600px;
        margin: 0 auto;
      }

      .container {
        max-width: 900px;
        margin-inline:  auto;
        padding: 2rem 1rem;
        position: relative;
      }
      .accordion {
        background: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
        margin-bottom: 0.75rem;
        position: relative;
        z-index: 1;
        transition: all 0.4s ease;
        border: 0.5px solid transparent;
      }
      .accordion:hover {
        box-shadow:
          0 0 0 0.5px rgba(92, 36, 131, 0.2),
          0 0 30px rgba(92, 36, 131, 0.12),
          0 0 50px rgba(92, 36, 131, 0.08),
          0 0 80px rgba(92, 36, 131, 0.04);
        border-color: rgba(92, 36, 131, 0.15);
        transform: translateY(-1px);
      }
      .accordion-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 1.5rem;
        cursor: pointer;
        background: white;
        border-bottom: 1px solid #f0f0f0;
        transition: all 0.4s ease;
        user-select: none;
      }
     .accordion:hover .accordion-header {
        background: linear-gradient(
          to right,
          rgba(92, 36, 131, 0.015),
          rgba(92, 36, 131, 0.025),
          rgba(92, 36, 131, 0.015)
        );
      }

      .accordion-header:hover {
        background: #f8f9fa;
      }

      .accordion-header.active {
        background: #f0f4f8;
        border-bottom: 1px solid #e0e8f0;
      }

      .accordion-title {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex: 1;
      }

      .section-number {
        background: #5c2483;
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 0.95rem;
        flex-shrink: 0;
        position: relative;
      }

      .section-number::before {
        content: "";
        position: absolute;
        width: 7px;
        height: 7px;
        background: white;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .accordion-header h2 {
        font-size: 1.05rem;
        color: #5c2483;
        font-weight: 600;
      }

      .accordion-icon {
        width: 20px;
        height: 20px;
        transition: transform 0.3s ease;
        flex-shrink: 0;
      }

      .accordion-icon svg {
        width: 100%;
        height: 100%;
        stroke: #546e7a;
        stroke-width: 2;
        fill: none;
      }

      .accordion-header.active .accordion-icon {
        transform: rotate(180deg);
      }

      .accordion-content {
        max-height: 0;
        overflow: hidden;
        transition:
          max-height 0.4s ease,
          padding 0.4s ease;
      }

      .accordion-content.active {
        max-height: 2000px;
      }

      .accordion-inner {
        padding: 1.25rem 1.5rem;
        color: #455a64;
        line-height: 1.7;
        font-size: 0.95rem;
      }

      .accordion-inner p {
        margin-bottom: 0.75rem;
      }

      .accordion-inner p:last-child {
        margin-bottom: 0;
      }

      @media (max-width: 768px) {
        .hero h1 {
          font-size: 1.75rem;
        }

        .hero p {
          font-size: 0.95rem;
        }

        .accordion-header {
          padding: 0.875rem 1rem;
        }

        .accordion-inner {
          padding: 1rem;
        }

        .accordion-header h2 {
          font-size: 0.95rem;
        }

        .section-number {
          width: 28px;
          height: 28px;
        }

        .section-number::before {
          width: 6px;
          height: 6px;
        }
      `}</style>
      <div className="bg-[#B3594D] min-h-screen">
        {/* HERO SECTION */}
        <div className="hero hero-section-text-container">
          <div className="hero-content">
            <h1>{headerContent?.Heading}</h1>
            <h2 className="text-[#EDD2B9]">{headerContent?.PageDescription}</h2>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="container bg-[#B3594D]">
          {accordionItems.map((item, index) => (
            <div className="accordion" key={item.documentId}>
              <div className="accordion-header" onClick={(e) => toggleAccordion(e.currentTarget)}>
                <div className="accordion-title">
                  <span className="section-number"></span>
                  <h2>{item.PolicyName}</h2>
                </div>
                <div className="accordion-icon">
                  <svg viewBox="0 0 24 24">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </div>

              <div className="accordion-content">
                <div className="accordion-inner">
                  {item.PolicyDescription.split("\n\n").map((para, i) => (
                    <p key={i}>
                      {para.split("\n").map((line, j) => (
                        <span key={j}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
